<template>
  <div class="bbe-mail-tracker" v-if="hasTracker" @mouseenter="updateCounter">
    <i class="bbe-mail-tracker__icon bbe-mail-tracker__icon_mark email-icon-tracker-mark"/>
    <i class="bbe-mail-tracker__icon bbe-mail-tracker__icon_indicator email-icon-tracker-indicator"
       :class="{'bbe-mail-tracker__icon_indicator_opened': openCounter}"/>
    <div class="bbe-mail-tracker-info">
      <div class="bbe-mail-tracker-info-read" v-if="openCounter">
        <div class="bbe-mail-tracker-info-read__item bbe-mail-tracker-info-read__item_count">
          Your email was opened {{ openCounter }} times
        </div>
        <div class="bbe-mail-tracker-info-read__item" v-if="lastOpened">
          Opened {{ lastOpened }}
        </div>
        <div class="bbe-mail-tracker-info-read__item" v-if="firstOpened">
          First opened {{ firstOpened }}
        </div>
      </div>
      <div class="bbe-mail-tracker-info__unread" v-else>
        {{ unreadMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import {debounce, get, orderBy} from 'lodash'
import moment from 'moment'
import emailTrackerApi from '@/api/EmailTracker/api'

export default {
  name: 'MailTrackerIndicator',
  props: ['thread'],
  data () {
    return {}
  },
  computed: {
    activeUser () {
      return this.$store.getters.userInfo || this.$store.getters.activeUser
    },
    lastTracker () {
      return orderBy(this.thread.tracking, tracker => new Date(tracker.lastOpenDate), ['desc'])[0]
    },
    firstTracker () {
      return orderBy(this.thread.tracking, tracker => new Date(tracker.lastOpenDate), ['asc'])[0]
    },
    hasTracker () {
      return get(this.lastTracker, 'id', '')
    },
    openCounter () {
      return this.thread.tracking.reduce((sum, item) => {
        sum += item.count
        return sum
      }, 0)
    },
    lastOpened () {
      const date = get(this.lastTracker, 'lastOpenDate', '')
      return this.getFormatDate(date)
    },
    firstOpened () {
      const date = get(this.firstTracker, 'firstOpenDate', '')
      return this.getFormatDate(date)
    },
    unreadMessage () {
      return `${this.clientMessage} hasn't read your email yet`
    },
    clientMessage () {
      const email = get(this.thread, 'to.email', '')
      return get(this.thread, 'to.name', email)
    },
    updateCounter () {
      return debounce(this.getTrackers, 1000)
    }
  },
  methods: {
    getTrackers () {
      const threadId = get(this.thread, 'id', '')
      const userEmail = get(this.activeUser, 'email', '')
      const userId = get(this.activeUser, 'gmail.email', userEmail)
      emailTrackerApi.getEmailTracker({threadId, userId})
        .then(({data = []}) => {
          this.$set(this.thread, 'tracking', data)
        })
        .catch(err => {
          console.error(err)
        })
    },
    getFormatDate (date) {
      const momentDate = moment(date)
      const isValidDate = momentDate.isValid()
      if (!isValidDate) return ''
      const duration = moment.duration({ from: new Date(), to: date })
      const durationMonth = duration.asMonths()
      const monthAgo = Math.abs(Math.round(durationMonth))
      return monthAgo ? momentDate.format('DD MMM YY') : momentDate.fromNow()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bbe-mail-tracker {
  @include global-font;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 18px;
  height: 18px;

  &:hover &-info {
    transform: scale(1);
  }

  &-info {
    position: absolute;
    top: 20px;
    left: 0;
    min-width: 184px;
    color: $color-white;
    font-size: 11px;
    padding: 8px;
    background: rgba($color-black, 0.53);
    box-shadow: 0 0 12px rgba($color-black, 0.12);
    border-radius: 5px;
    z-index: 3;
    pointer-events: none;
    user-select: none;
    transform: scale(0);
    transition: 0.3s;

    &__unread {
      white-space: nowrap;
    }

    &-read {
      display: grid;
      align-items: center;
      grid-gap: 2px;

      &__item {
        white-space: nowrap;
        line-height: 13px;

        &_count {
          font-weight: 600;
          font-size: 12px;
          margin-bottom: 2px;
          line-height: 14px;
        }
      }
    }
  }

  &__icon {
    font-size: 10px;

    &:before {
      margin: 0;
    }

    &_mark {
      color: $color-accent;
    }

    &_indicator {
      position: absolute;
      right: 0;
      color: $color-silver-chalice;

      &_opened {
        color: $color-accent;
        opacity: 0.6;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/MailTracker/MailTrackerIndicator.vue